function apiUrl(path) {
  const root = (process.env.VUE_APP_API_BASE || '').replace(/\/$/, '')
  const p = path.startsWith('/') ? path : `/${path}`
  return root ? `${root}${p}` : p
}

let cachedPublicKey = ''
let cachedAt = 0
const CACHE_MS = 10 * 60 * 1000

function pemToArrayBuffer(pem) {
  const b64 = String(pem)
    .replace(/-----BEGIN PUBLIC KEY-----/g, '')
    .replace(/-----END PUBLIC KEY-----/g, '')
    .replace(/\s+/g, '')
  const binary = atob(b64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes.buffer
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}

async function fetchPublicKey() {
  const now = Date.now()
  if (cachedPublicKey && now - cachedAt < CACHE_MS) {
    return cachedPublicKey
  }
  const res = await fetch(apiUrl('/api/auth/public-key'))
  const data = await res.json().catch(() => ({}))
  if (!data || !data.ok || !data.publicKey) {
    throw new Error('PUBLIC_KEY_UNAVAILABLE')
  }
  cachedPublicKey = data.publicKey
  cachedAt = now
  return cachedPublicKey
}

async function importRsaPublicKey(pem) {
  return crypto.subtle.importKey(
    'spki',
    pemToArrayBuffer(pem),
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  )
}

export async function encryptPasswordForAuth(password) {
  const pem = await fetchPublicKey()
  const key = await importRsaPublicKey(pem)
  const payload = JSON.stringify({ p: String(password), t: Date.now() })
  const encrypted = await crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    key,
    new TextEncoder().encode(payload)
  )
  return arrayBufferToBase64(encrypted)
}
